// AGC: Admin Panel - Formula Preview Component
// AGC: Displays algorithm formulas in code block format

import React from 'react'

interface FormulaPreviewProps {
  title: string
  formula: string
  bgColor?: string
  borderColor?: string
  titleColor?: string
  codeColor?: string
}

/**
 * AGC: FormulaPreview - Display algorithm formulas
 * AGC: Shows mathematical formulas with syntax highlighting in a code block
 */
export const FormulaPreview: React.FC<FormulaPreviewProps> = ({
  title,
  formula,
  bgColor = '#f0fdf4',
  borderColor = '#bbf7d0',
  titleColor = '#166534',
  codeColor = '#22c55e',
}) => (
  <div 
    className="mt-6 p-5 rounded-xl"
    style={{ 
      backgroundColor: bgColor,
      border: `1px solid ${borderColor}`,
    }}
  >
    <h4 
      className="text-sm font-semibold mb-3"
      style={{ color: titleColor }}
    >
      📝 {title}
    </h4>
    <pre 
      className="p-4 bg-slate-800 rounded-lg text-sm font-mono overflow-x-auto whitespace-pre-wrap"
      style={{ color: codeColor }}
    >
      {formula}
    </pre>
  </div>
)

export default FormulaPreview


